import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';
import { Link, useParams } from "react-router-dom";
import moment from "jalali-moment";
import toast from "react-hot-toast";

import Layout from "../../../component/Layout/Layout";
import Card from "../../../component/Layout/theme/card";
import LogOut from "../../../component/dashboard/user/logout/logout";
import PageChange from "../../../component/pageChange";
import { QRCode } from "react-qrcode-logo";
import CustomModal from "../../../component/Modal/custom";


function IndexPage() {
    const params = useParams();
    var { t } = useTranslation()
    const { login, token, user } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(false);
    const [data, setData] = useState(null);
    const [indexSelectItem, setIndexSelectItem] = useState(0);
    const [showModalRemove, setShowModalRemove] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [showModalPreviewModel, setShowModalPreviewModel] = useState(false);
    const [contentDataEdit, setContentDataEdit] = useState("null");
    const [contentDataTypeEdit, setContentDataTypeEdit] = useState(null);
    const [contentDataErrorEdit, setContentDataErrorEdit] = useState(null);
    const [glbContentData, setGlbContentData] = useState("null")
    const [glbContentError, setGlbContentError] = useState(null)
    const [usdzContentData, setUsdzContentData] = useState("null")
    const [usdzContentError, setUsdzContentError] = useState(null)

    const qrSize = 1000;
    const [stepPage, setStepPage] = useState(1)

    var durationConvert = 0;
    const [progressBar, setProgressBar] = useState(0);
    const [progressDone, setProgressDone] = useState([]) // MARKER, VIDEO



    const axiosInstance = axios.create({
        baseURL: `${process.env.REACT_APP_SERVER}`,
        timeout: 3000000 // only wait
    });

    const editStatusProcess = (title, status) => {
        setProgressDone(prevState => {
            return prevState.map((item) => {
                return item.title === title ? { title: title, status: status } : item
            })
        })
    }


    useEffect(() => {

        if (!login) {
            window.location.href = '/auth'
        } else {
            if (params.id != "null") {
                getAugmentedReality(params.id)
            } else {
                window.location.href = '/projects'
            }
        }
    }, [])

    async function getAugmentedReality(id) {
        await fetch(`${process.env.REACT_APP_SERVER}/api/nft/${id}`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/login';
                    }
                    if (result.status === "success") {
                        setIsDataLoad(true)
                        setData(result.data)
                        document.title = `ویرایش پروژه "${result.data.name}"`
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = '/login';
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }

    const removeAugmentedReality = async (dataRemove, index) => {
        if (dataRemove.image.length > 1) {
            await fetch(`${process.env.REACT_APP_SERVER}/api/nft/${dataRemove._id}?index=${index}`, {
                method: "DELETE",
                headers: {
                    Authorization: "ArNew " + token,
                },
            }).then((res) => {
                res
                    .json()
                    .then((result) => {
                        if (!result.data) {
                            LogOut();
                            toast.error("شما دسترسی ندارید");
                            window.location.href = '/login';
                        }
                        if (result.status === "success") {
                            setIsDataLoad(true)
                            setData(result.data)
                        } else {
                            toast.error(result.msg);
                            LogOut();
                            window.location.href = '/login';
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            });
        } else {
            toast.error("شما نمی توانید تمام نشانگر ها را حذف کنید");
        }
    }

    const downloadQRCode = (name) => {
        const canvas = document.getElementById("QR");
        if (canvas) {
            const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = `${name}.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    const htmlEditPopupMarker = (dataEdit, index) => {
        var dataType = dataEdit.video[index] == null ? "OBJ" : "VIDEO";
        const contentData = dataType == "OBJ" ? `${process.env.REACT_APP_SERVER}/uploads/${dataEdit.user.username}/3d_model/${dataEdit.glb_model[index]}` : `${process.env.REACT_APP_SERVER}/uploads/${dataEdit.user.username}/video/${dataEdit.video[index]}`

        const checkSetContentData = (e) => {
            if (e.target.files[0].size > 50000001) {
                setContentDataErrorEdit("حجم فایل شما بیش از حد مجاز می باشد")
                return;
            }
            const name = e.target.files[0].name
            const array = name.split(".");
            const format = array[array.length - 1];
            if (format.toLowerCase() != "mp4" && format.toLowerCase() != "mov" && format.toLowerCase() != "glb") {
                setContentDataErrorEdit("فرمت صحیح نمی باشد")
            } else {
                if (format.toLowerCase() == "mp4" || format.toLowerCase() == "mov") {
                    setContentDataTypeEdit("VIDEO")
                }
                if (format.toLowerCase() == "glb") {
                    setContentDataTypeEdit("OBJ")
                }
                setContentDataErrorEdit(null)
                setContentDataEdit(e.target.files[0])
            }
        }

        return (
            stepPage == 1 ?
                <>
                    <div className="max-w-[400px] flex flex-col gap-2">
                        <h1 className="col-span-2 font-extrabold text-xl text-start text-black my-auto mt-8 mx-5">محتوا</h1>
                        <h4 className="font-normal text-lg text-start text-gray-600 mx-5 my-3">
                            ویرایش محتوا، محتوا شما می تواند ویدئو یا فایل سه بعدی باشد.
                        </h4>
                        <div className="flex items-center justify-center w-full">
                            <label htmlFor="dropzone-file-content" className={`relative flex flex-col items-center justify-center w-full h-64 border-2 ${contentDataErrorEdit ? "border-red-500" : "border-gray-300"} border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover: bg-bray-800 hover:bg-gray-100`}>
                                {contentDataEdit != null ?
                                    (
                                        <>
                                            {contentDataTypeEdit == null ?
                                                dataType == "VIDEO" ?
                                                    (
                                                        <>
                                                            <video className="free-image p-3" autoPlay={false} controls={true} src={contentData} />
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>
                                                            <model-viewer loading="eager" auto-rotate alt="Uploaded Model" src={contentData} shadow-intensity="1" camera-controls touch-action="pan-y"></model-viewer>
                                                        </>
                                                    )
                                                :
                                                contentDataTypeEdit == "VIDEO" ?
                                                    (
                                                        <>
                                                            <video className="free-image p-3" autoPlay={false} controls={true} src={URL.createObjectURL(contentDataEdit)} />
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>
                                                            <model-viewer loading="eager" auto-rotate alt="Uploaded Model" src={URL.createObjectURL(contentDataEdit)} shadow-intensity="1" camera-controls touch-action="pan-y"></model-viewer>
                                                        </>
                                                    )
                                            }
                                            <div
                                                onClick={() => { setContentDataEdit(null) }}
                                                className="absolute right-0 top-0 m-2 p-2 shadow-lg  border border-1 border-gray-300 rounded-lg bg-white hover:border-red-600 hover:bg-red-500 hover:shadow-slate-400 cursor-pointer">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z" /></svg>
                                            </div>
                                        </>
                                    )
                                    :
                                    (
                                        <>
                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                                </svg>
                                                <p className="text-red-500 text-sm mb-2">{contentDataErrorEdit}</p>
                                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">برای بارگذاری کلیک کنید</span> یا فایل را اینجا رها کنید</p>
                                                <p className="text-xs text-gray-500">MP4, MOV, GLB (MAX. 50 MB)</p>
                                            </div>

                                            <input
                                                id="dropzone-file-content"
                                                type="file"
                                                className="hidden"
                                                multiple={false}
                                                onChange={(e) => {
                                                    if (e.target.files.length > 0) {
                                                        checkSetContentData(e)
                                                    }
                                                }}
                                            />
                                        </>
                                    )
                                }
                            </label>
                        </div>
                        {contentDataTypeEdit == null && dataType == "VIDEO" || contentDataTypeEdit != "VIDEO" &&
                            (
                                <div className="flex mt-2 mx-1 cursor-pointer text-blue-700 font-bold gap-1">

                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 my-auto" viewBox="0 0 512 512"><path fill="#1A56DB" d="M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z" /></svg>

                                    <a href={`/projects/edit/editor/${params.id}/${index}`}>ویرایش پیشرفته مدل سه بعدی</a>
                                </div>
                            )
                        }

                    </div>
                </>
                :
                <>
                    <div className="max-w-[400px]">
                        <div className="m-auto w-1/2 lg:w-1/3 xl:w-1/3">
                            <img className="free-image w-full object-cover rounded-lg" src={process.env.REACT_APP_ADDRESS + "/panel/upload-process.gif"} />
                        </div>

                        <div className="mt-8" role="status">
                            <span className="p-2">درحال ویرایش واقعیت افزوده هستیم، این پردازش به حجم داده های شما بستگی دارد.</span>
                            <div className="my-4">
                                <div className="w-full mt-4 bg-gray-200 rounded-full dark:bg-gray-700">
                                    <div id="progressBar" className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">{progressBar}%</div>
                                </div>
                            </div>
                        </div>
                        {progressDone.map((item, index) => {
                            return (
                                <div key={index} className="flex p-2">
                                    {
                                        item.status == "DONE" ?
                                            (
                                                <>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="#00ac8b" height="1.2em" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
                                                    <div className="px-2 font-normal text-base text-black">{item.title}</div>
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="inline text-gray-200 animate-spin fill-blue-600" height="1.2em" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                    </svg>
                                                    <span className="px-2 font-normal text-base text-black">{item.title}</span>
                                                </>
                                            )
                                    }
                                </div>
                            )
                        })}
                    </div>
                </>
        )
    }

    const htmlEditPopupMarkerLess = (dataEdit, index) => {

        const checkSetContentData = (e, type) => {
            if (e.target.files[0].size > 50000001) {
                if (type == "GLB") {
                    setGlbContentError("حجم فایل شما بیش از حد مجاز می باشد")
                }
                if (type == "USDZ") {
                    setUsdzContentError("حجم فایل شما بیش از حد مجاز می باشد")
                }
                return;
            }
            const name = e.target.files[0].name
            const array = name.split(".");
            const format = array[array.length - 1];

            if (type == "GLB") {
                if (format.toLowerCase() != "glb") {
                    setGlbContentError("فرمت صحیح نمی باشد")
                } else {
                    setGlbContentError(null)
                    setGlbContentData(e.target.files[0])
                }
            }

            if (type == "USDZ") {
                if (format.toLowerCase() != "usdz") {
                    setUsdzContentError("فرمت صحیح نمی باشد")
                } else {
                    setUsdzContentError(null)
                    setUsdzContentData(e.target.files[0])
                }
            }

        }

        return (
            stepPage == 1 ?
                <>
                    <div className="max-w-[400px] flex flex-col gap-2">
                        <h1 className="col-span-2 font-extrabold text-xl text-start text-black my-auto mt-8 mx-5">محتوا</h1>
                        <h4 className="font-normal text-lg text-start text-gray-600 mx-4 my-3">
                            ویرایش محتوا، محتوا شما می تواند فایل سه بعدی باشد.
                        </h4>

                        <h3 className="col-span-2 font-extrabold text-base text-start text-black my-auto mt-8 mx-5">بارگذاری مدل GLB (برای دستگاه های اندروید)</h3>
                        <div className="flex items-center justify-center w-full my-3">
                            <label htmlFor="dropzone-file-glb" className={`relative flex flex-col items-center justify-center w-full h-32 border-2 ${glbContentError ? "border-red-500" : "border-gray-300"} border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 hover:bg-gray-100`}>
                                {glbContentData != null ?
                                    (
                                        <>
                                            <span>{glbContentData.name ? glbContentData.name : "GLB Model"}</span>
                                            <div
                                                onClick={() => { setGlbContentData(null); setGlbContentError(null) }}
                                                className="absolute right-0 top-0 m-2 p-2 shadow-lg  border border-1 border-gray-300 rounded-lg bg-white hover:border-red-600 hover:bg-red-500 hover:shadow-slate-400 cursor-pointer">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z" /></svg>
                                            </div>

                                        </>
                                    )
                                    :
                                    (
                                        <>
                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                                </svg>
                                                <p className="text-red-500 text-sm mb-2">{glbContentError}</p>
                                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">برای بارگذاری کلیک کنید</span> یا فایل را اینجا رها کنید</p>
                                                <p className="text-xs text-gray-500">GLB (MAX. 50 MB)</p>
                                            </div>
                                            <input
                                                id="dropzone-file-glb"
                                                type="file"
                                                className="hidden"
                                                multiple={false}
                                                onChange={(e) => {
                                                    if (e.target.files.length > 0) {
                                                        checkSetContentData(e, "GLB")
                                                    }
                                                }}
                                            />
                                        </>
                                    )
                                }

                            </label>
                        </div>

                        <h3 className="col-span-2 font-extrabold text-base text-start text-black my-auto mt-8 mx-5">بارگذاری مدل USDZ (برای دستگاه های آی او اس)</h3>
                        <div className="flex items-center justify-center w-full my-3">
                            <label htmlFor="dropzone-file-usdz" className={`relative flex flex-col items-center justify-center w-full h-32 border-2 ${usdzContentError ? "border-red-500" : "border-gray-300"} border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 hover:bg-gray-100`}>
                                {usdzContentData != null ?
                                    (
                                        <>
                                            <span>{usdzContentData.name ? usdzContentData.name : "USDZ Model"}</span>
                                            <div
                                                onClick={() => { setUsdzContentData(); setUsdzContentError(null) }}
                                                className="absolute right-0 top-0 m-2 p-2 shadow-lg  border border-1 border-gray-300 rounded-lg bg-white hover:border-red-600 hover:bg-red-500 hover:shadow-slate-400 cursor-pointer">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z" /></svg>
                                            </div>

                                        </>
                                    )
                                    :
                                    (
                                        <>
                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                                </svg>
                                                <p className="text-red-500 text-sm mb-2">{usdzContentError}</p>
                                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">برای بارگذاری کلیک کنید</span> یا فایل را اینجا رها کنید</p>
                                                <p className="text-xs text-gray-500">USDZ (MAX. 50 MB)</p>
                                            </div>
                                            <input
                                                id="dropzone-file-usdz"
                                                type="file"
                                                className="hidden"
                                                multiple={false}
                                                onChange={(e) => {
                                                    if (e.target.files.length > 0) {
                                                        checkSetContentData(e, "USDZ")
                                                    }
                                                }}
                                            />
                                        </>
                                    )
                                }

                            </label>
                        </div>

                    </div>
                </>
                :
                <>
                    <div className="max-w-[400px]">
                        <div className="m-auto w-1/2 lg:w-1/3 xl:w-1/3">
                            <img className="free-image w-full object-cover rounded-lg" src={process.env.REACT_APP_ADDRESS + "/panel/upload-process.gif"} />
                        </div>

                        <div className="mt-8" role="status">
                            <span className="p-2">درحال ویرایش واقعیت افزوده هستیم، این پردازش به حجم داده های شما بستگی دارد.</span>
                            <div className="my-4">
                                <div className="w-full mt-4 bg-gray-200 rounded-full dark:bg-gray-700">
                                    <div id="progressBar" className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">{progressBar}%</div>
                                </div>
                            </div>
                        </div>
                        {progressDone.map((item, index) => {
                            return (
                                <div key={index} className="flex p-2">
                                    {
                                        item.status == "DONE" ?
                                            (
                                                <>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="#00ac8b" height="1.2em" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
                                                    <div className="px-2 font-normal text-base text-black">{item.title}</div>
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="inline text-gray-200 animate-spin fill-blue-600" height="1.2em" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                    </svg>
                                                    <span className="px-2 font-normal text-base text-black">{item.title}</span>
                                                </>
                                            )
                                    }
                                </div>
                            )
                        })}
                    </div>
                </>
        )
    }

    const ffmpeg = createFFmpeg({
        progress: (e) => {
            if (e.duration) {
                durationConvert = e.duration
            }
            if (e.time) {
                var fin = Math.round(((e.time + durationConvert) / durationConvert * 100) - 100)
                setProgressBar(fin)
                setTimeout(() => {
                    document.getElementById("progressBar").style.width = fin.toString() + "%";
                }, 100);
            }
        },
        log: true,
    });

    async function convertUserVideo(video) {
        await ffmpeg.load();
        ffmpeg.FS('writeFile', video.name, await fetchFile(video));
        await ffmpeg.run('-i', video.name, '-c:v', 'libx264', '-vf', 'scale=720:-2,format=yuv420p', '-c:a', 'copy', '-movflags', '+faststart', 'output.mp4');
        const data = ffmpeg.FS('readFile', 'output.mp4');
        const blob = new Blob([data.buffer], { type: 'video/mp4' })
        var file = blobToFile(blob, "final.mp4");
        return file;
    }

    function blobToFile(theBlob, fileName) {
        return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
    }

    const editAugmentedRealityMarker = async (id, index) => {

        if (contentDataEdit == "null" || contentDataEdit == null) {
            setShowModalEdit(false);
            return;
        }

        setProgressBar(0)

        if (contentDataTypeEdit == "VIDEO") {
            setProgressDone([{
                title: "احراز هویت",
                status: "DONE" // DONE, WAIT
            },
            {
                title: "آنالیز داده ها",
                status: "DONE" // DONE, WAIT
            },
            {
                title: "تبدیل ویدیو",
                status: "WAIT" // DONE, WAIT
            },
            {
                title: "ارسال داده ها به سرور",
                status: "WAIT" // DONE, WAIT
            }])
        } else {
            setProgressDone([{
                title: "احراز هویت",
                status: "DONE" // DONE, WAIT
            },
            {
                title: "آنالیز داده ها",
                status: "DONE" // DONE, WAIT
            },
            {
                title: "ارسال داده ها به سرور",
                status: "WAIT" // DONE, WAIT
            }])
        }

        setStepPage(2)

        const formData = new FormData();

        if (contentDataTypeEdit == "VIDEO") {
            const videoConverted = await convertUserVideo(contentDataEdit).catch(error => {
                console.error("Convert error:", error)
                return contentDataEdit;
            });
            formData.append("video", videoConverted);
            editStatusProcess("تبدیل ویدیو", "DONE")
        } else {
            formData.append("glb", contentDataEdit);
        }

        await axiosInstance.put(`/api/nft/${id}?index=${index}`, formData, {
            headers: {
                Authorization: "ArNew " + token,
            },
            onUploadProgress: data => {
                var percentComplete = Math.ceil((100 * data.loaded) / data.total);
                setProgressBar(percentComplete)
                document.getElementById("progressBar").style.width = percentComplete.toString() + "%";
            }
        })
            .then(
                function (response) {
                    if (response.data.status === "success") {
                        setContentDataEdit("null")
                        setContentDataTypeEdit(null)
                        setContentDataErrorEdit(null)
                        editStatusProcess("ارسال داده ها به سرور", "DONE")
                        setData(response.data.data)
                        setStepPage(1);
                        setShowModalEdit(false);
                    } else {
                        toast.error(response?.data?.msg);
                    }
                }
            ).catch(function ({ response }) {
                if (response.status !== 200) {
                    toast.error(response?.data?.msg)
                }
            });
    }

    const editAugmentedRealityMarkerLess = async (id, index) => {

        if (glbContentData == "null" || glbContentData == null && usdzContentData == "null" || usdzContentData == null) {
            setShowModalEdit(false);
            return;
        }

        setProgressBar(0)

        setProgressDone([{
            title: "احراز هویت",
            status: "DONE" // DONE, WAIT
        },
        {
            title: "آنالیز داده ها",
            status: "DONE" // DONE, WAIT
        },
        {
            title: "ارسال داده ها به سرور",
            status: "WAIT" // DONE, WAIT
        }])


        setStepPage(2)

        const formData = new FormData();

        formData.append("glb", glbContentData);
        formData.append("usdz", usdzContentData);

        await axiosInstance.put(`/api/nft/${id}?index=${index}`, formData, {
            headers: {
                Authorization: "ArNew " + token,
            },
            onUploadProgress: data => {
                var percentComplete = Math.ceil((100 * data.loaded) / data.total);
                setProgressBar(percentComplete)
                document.getElementById("progressBar").style.width = percentComplete.toString() + "%";
            }
        })
            .then(
                function (response) {
                    if (response.data.status === "success") {
                        setGlbContentData("null")
                        setUsdzContentData("null")
                        setGlbContentError(null)
                        setUsdzContentError(null)
                        editStatusProcess("ارسال داده ها به سرور", "DONE")
                        setData(response.data.data)
                        setStepPage(1);
                        setShowModalEdit(false);
                    } else {
                        toast.error(response?.data?.msg);
                    }
                }
            ).catch(function ({ response }) {
                if (response.status !== 200) {
                    toast.error(response?.data?.msg)
                }
            });
    }

    const changeCheckActivation = async (event) => {
        setIsDataLoad(false)

        await axiosInstance.put(`/api/nft/deactivation/${data._id}`, { status: event.currentTarget.checked }, {
            headers: {
                Authorization: "ArNew " + token,
            },
        })
            .then(
                function (response) {
                    setIsDataLoad(true)
                    if (response.data.status === "success") {
                        const temp = { ...data }
                        temp.status = response.data.data.status
                        setData(temp)
                    } else {
                        toast.error(response?.data?.msg);
                    }
                }
            ).catch(function ({ response }) {
                setIsDataLoad(true)
                if (response.status !== 200) {
                    toast.error(response?.data?.msg)
                }
            });

    }

    const getLinkForAR = () => {
        if (user.personalized_access) {
            return user.personalized_site
        } else {
            return process.env.REACT_APP_CLIENT
        }
    }

    const checkColorLimited = (limited_view, view) => {
        if (limited_view) {
            if (limited_view != 0) {
                if (view > limited_view) {
                    return "text-red-600"
                } else {
                    return "text-black"
                }
            }
        }
        return "text-black"
    }


    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (

                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md">
                        <div className="grid grid-cols-3 gap-1">
                            <div className="col-span-2">
                                <h1 className="font-extrabold text-2xl text-start text-black mt-5">پروژه «{data.name}»</h1>
                                <h4 className="font-normal text-lg text-start text-gray-500 mt-2">این نمای پروژه شماست. در اینجا می توانید واقعیت افزوده جدید به پروژه خود را اضافه، حذف و ویرایش کنید.</h4>
                            </div>
                            <div className="col-span-1 flex flex-wrap  justify-end text-end my-auto gap-2">
                                <Link to={`/projects/edit/add/${data.types}/${data._id}?name=${data.name}`}>
                                    <button className=" font-medium text-sm text-white  bg-green-600 hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-blue-300  rounded-lg px-5 py-2.5 text-center">افزودن {data.types == "MARKER" ? "نشانگر" : "مدل"}</button>
                                </Link>
                                <Link to={`/projects/edit-project/${data._id}`}>
                                    <button className=" font-medium text-sm text-white  bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300  rounded-lg px-5 py-2.5 text-center">ویرایش پروژه</button>
                                </Link>
                            </div>
                        </div>


                        <div className="p-8 bg-[#f2f4f6] rounded-lg border border-[#e6e8ea] mt-8">
                            <div className="grid grid-cols-2 xl:grid-cols-6 lg:grid-cols-3 gap-3">
                                <div className="my-auto">
                                    <div className='canvas-qr-card-edit'>
                                        <QRCode
                                            value={`${getLinkForAR()}/view/${data.user.username}/${data.url}`}
                                            size={qrSize}
                                            logoImage={user.logo ? process.env.REACT_APP_SERVER + user.logo : process.env.REACT_APP_ADDRESS + "/logo.png"}
                                            fgColor={"#000"}
                                            removeQrCodeBehindLogo={false}
                                            quietZone={5}
                                            eyeRadius={
                                                [
                                                    { // top/left eye
                                                        outer: [10, 10, 0, 10],
                                                        inner: [0, 10, 10, 10],
                                                    },
                                                    [10, 10, 10, 0], // top/right eye
                                                    [10, 0, 10, 10], // bottom/left
                                                ]
                                            }
                                            enableCORS={true}
                                            logoWidth={qrSize / 1.6}
                                            logoHeight={qrSize / 1.6}
                                            logoOpacity={0.4}
                                            ecLevel={'Q'}
                                            qrStyle={"dots"} // squares
                                            id={"QR"}
                                        />
                                    </div >
                                </div >
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">تعداد {data.types == "MARKER" ? "نشانگر" : "مدل"}</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{data.image.length}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">تعداد بازدید</span>
                                    <h3 className={`font-extrabold text-xl text-start ${checkColorLimited(data.limited_view, data.view)} py-5`}>
                                        {data.view} / {data.limited_view == 0 ? (<span className="text-base">نامحدود</span>) : data.limited_view}
                                    </h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">رمزعبور</span>
                                    {
                                        data["password"] ?
                                            (
                                                <div className="py-5">
                                                    <a href="#" className="font-extrabold text-xl text-start text-blue-600 dark:text-blue-500">مشاهده رمز</a>
                                                    {/* <h3 className="font-extrabold text-xl text-start text-black ">مشاهده</h3> */}
                                                </div>
                                            )
                                            :
                                            (
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">بدون رمز عبور</h3>
                                            )
                                    }
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">تاریخ ایجاد</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{moment(new Date(parseInt(data.create_in))).format(
                                        "jYYYY/jMM/jDD"
                                    )}</h3>
                                </div>
                                <div className="grid gap-1">
                                    <div className="flex w-full justify-center m-auto">
                                        <button onClick={() => downloadQRCode(data.name)} className="font-medium text-sm text-white bg-black hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg sm:w-auto px-5 py-2.5 text-center">دانلود QRCode</button>
                                    </div>
                                    <div className="flex w-full justify-center m-auto">
                                        <button onClick={() => { navigator.clipboard.writeText(`${getLinkForAR()}/view/${data.user.username}/${data.url}`); toast.success("لینک واقعیت افزوده در کلیپ بورد ذخیره شد") }} className="font-medium text-sm text-gray-700 focus:ring-4 focus:outline-none rounded-lg sm:w-auto px-5 py-2.5 text-center">کپی لینک</button>
                                    </div>
                                </div>
                            </div >
                        </div >



                        <div className="relative overflow-x-auto mt-8">
                            <table className="w-full text-sm text-right text-gray-500 ">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
                                    <tr>
                                        <th scope="col" className="px-6 py-3">
                                            {data.types == "MARKER" ? "نشانگر" : "مدل"}
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            نوع
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            وضعیت
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            عملیات
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data.image.map((item, index) => {
                                            const url = `${process.env.REACT_APP_SERVER}/uploads/${data.user.username}`;
                                            return (
                                                <tr key={index} className={`bg-white ${data.image.length != index + 1 ? "border-b" : null}`}>
                                                    {data.types == "MARKER" ?
                                                        (
                                                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                                                <div className="grid place-content-start">
                                                                    <img className="free-image w-6 rounded-sm object-cover" src={`${url}/image/${item}`} />
                                                                </div>
                                                            </th>
                                                        ) : (
                                                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                                                <div className="grid place-content-start">
                                                                    <a onClick={() => { setShowModalPreviewModel(true); setIndexSelectItem(index) }} className="font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer">مشاهده مدل</a>
                                                                </div>
                                                            </th>
                                                        )
                                                    }
                                                    <td className="px-6 py-4">
                                                        {data.video[index] != null ? "ویدیو" : "سه بعدی"}
                                                    </td>
                                                    <td className="px-6 py-4" dir="rtl">

                                                        <label className="inline-flex items-center cursor-pointer">
                                                            <input type="checkbox" value="" className="sr-only peer" onChange={changeCheckActivation} defaultChecked={data.status | false} />
                                                            <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                                            <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 mx-2">
                                                                {
                                                                    data.status == true ? "فعال" : "غیر فعال"
                                                                }
                                                            </span>
                                                        </label>
                                                    </td>
                                                    <td className="px-6 py-5">
                                                        <div className="flex gap-3">
                                                            <a onClick={() => { setShowModalEdit(true); setIndexSelectItem(index) }} className="font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer">ویرایش</a>
                                                            <a onClick={() => { setShowModalRemove(true); setIndexSelectItem(index) }} className="font-medium text-red-600 dark:text-red-500 hover:underline cursor-pointer">حذف</a>
                                                        </div>
                                                    </td>
                                                </tr>

                                            )
                                        })
                                    }

                                </tbody>
                            </table>
                        </div>
                        <CustomModal
                            showModal={showModalEdit}
                            closeButtonDisable={true}
                            setShowModal={setShowModalEdit}
                            title="ویرایش"
                            html={data.types == "MARKER" ? htmlEditPopupMarker(data, indexSelectItem) : htmlEditPopupMarkerLess(data, indexSelectItem)}
                            buttons={[
                                < button
                                    key="cancel_edit_btn"
                                    onClick={() => { setShowModalEdit(false); setContentDataEdit("null"); setContentDataTypeEdit(null); setContentDataErrorEdit(null) }}
                                    className={`w-full bg-gray-500 hover:shadow-lg text-white active:bg-gray-600 font-bold uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
                                    type="button"
                                >
                                    انصراف
                                </button >,
                                < button
                                    key="edit_btn"
                                    onClick={() => { data.types == "MARKER" ? editAugmentedRealityMarker(data._id, indexSelectItem) : editAugmentedRealityMarkerLess(data._id, indexSelectItem) }}
                                    className={`w-full bg-red-500 hover:shadow-lg text-white active:bg-red-600 font-bold uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
                                    type="button"
                                >
                                    ویرایش
                                </button >
                            ]}
                        />
                        <CustomModal
                            showModal={showModalRemove}
                            setShowModal={setShowModalRemove}
                            title="حذف؟"
                            html={
                                <p className="w-96">
                                    آیا مطمئن به حذف آیتم هستید؟
                                    <br />
                                    <span>درصورت حذف دیگر قابل بازگردانی نیست!</span>
                                </p>
                            }
                            buttons={[
                                < button
                                    key="cancel_remove_btn"
                                    onClick={() => { setShowModalRemove(false) }}
                                    className={`w-full bg-gray-500 hover:shadow-lg text-white active:bg-gray-600 font-bold uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
                                    type="button"
                                >
                                    انصراف
                                </button >,
                                < button
                                    key="remove_btn"
                                    onClick={() => { setShowModalRemove(false); removeAugmentedReality(data, indexSelectItem) }}
                                    className={`w-full bg-red-500 hover:shadow-lg text-white active:bg-red-600 font-bold uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
                                    type="button"
                                >
                                    حذف
                                </button >
                            ]}
                        />
                        <CustomModal
                            showModal={showModalPreviewModel}
                            setShowModal={setShowModalPreviewModel}
                            title="مشاهده مدل"
                            html={
                                <p className="w-96 flex flex-col items-center justify-center">
                                    <model-viewer auto-rotate alt="Preview model" src={`${process.env.REACT_APP_SERVER}/uploads/${data.user.username}/3d_model/${data.glb_model[indexSelectItem]}`} shadow-intensity="1" camera-controls touch-action="pan-y"></model-viewer>
                                </p>
                            }
                            buttons={[
                                < button
                                    key="cancel_remove_btn"
                                    onClick={() => { setShowModalPreviewModel(false) }}
                                    className={`w-full bg-gray-500 hover:shadow-lg text-white active:bg-gray-600 font-bold uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
                                    type="button"
                                >
                                    بستن
                                </button >,
                            ]}
                        />
                    </div >
                ) : (
                    <PageChange />
                )}

            </Card >
        </>
    )
}

export default IndexPage